import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { useStyles } from "./searchV2Styles";
import { Box, IconButton, Snackbar, SnackbarCloseReason } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import sanitizeHtml from "sanitize-html";
import { useTranslation } from "react-i18next";

export const SearchV2 = (): React.ReactElement => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState("");
  const [open, setOpen] = useState(false);
  const vertical = "top";
  const horizontal = "left";
  const navigate = useNavigate();
  const searchPage = process.env.REACT_APP_ENABLE_SEARCHV2_IBF === "true" ? "searchV2" : "search";

  const onChange = (event: any) => {
    setSearchText(event.target.value);
  };

  const handleClose = (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const onKeyPress = (e: any) => {
    if (e.code == "Enter") {
      const sanitizeText: string = sanitizeHtml(searchText.trim(), {
        allowedTags: [],
        allowedAttributes: {},
      });
      if (sanitizeText == "") {
        setOpen(true);
        return;
      }
      navigate(`/${searchPage}`, { state: { searchtext: sanitizeText } });
    }
  };
  const handlesearch = () => {
    const sanitizeText: string = sanitizeHtml(searchText.trim(), {
      allowedTags: [],
      allowedAttributes: {},
    });
    if (sanitizeText == "") {
      setOpen(true);
      return;
    }
    navigate(`/${searchPage}`, { state: { searchtext: sanitizeText } });
  };

  return (
    <Box className={classes.search}>
      <IconButton
        className={classes.searchIconButton}
        onClick={handlesearch}
        aria-label={t("search").toLowerCase()}
        size="large">
        <SearchIcon />
      </IconButton>
      <InputBase
        placeholder="Search for a product"
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}
        onChange={onChange}
        onKeyPress={onKeyPress}
        inputProps={{ "aria-label": t("search").toLowerCase() }}
        type="text"
        value={searchText}
        required
      />
      <Box>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical, horizontal }}
          style={{ position: "inherit" }}
        >
          <Alert
            classes={{ message: classes.alertIcon }}
            onClose={handleClose}
            severity="error"
            variant="filled"
            icon={<ErrorOutlineIcon role="img" aria-hidden={false} aria-label="Error" />}
          >
            Please type something to search
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
};
